import { supabase } from '@/config/supabase'
import type { DeadLetterItem, UUID } from '@/types/database'

export const dlqService = {
    async list() {
        const { data, error } = await supabase
            .schema('veicular_system')
            .from('veic_dead_letter_queue')
            .select('*')
            .order('created_at', { ascending: false })

        if (error) throw error
        return (data || []) as DeadLetterItem[]
    },

    async retry(id: UUID) {
        // @ts-ignore
        const { data, error } = await supabase
            .schema('veicular_system')
            .from('veic_dead_letter_queue')
            // @ts-ignore
            .update({ status: 'reprocessando', tentativas: 0 } as any)
            .eq('id', id)
            .select()
            .single()

        if (error) throw error
        return data
    },

    async discard(id: UUID) {
        // @ts-ignore
        const { error } = await supabase
            .schema('veicular_system')
            .from('veic_dead_letter_queue')
            // @ts-ignore
            .update({ status: 'descartado' } as any)
            .eq('id', id)

        if (error) throw error
    }
}
